export const GetAppSettings = 'api/restaurant/get_app_settings/{appId}';
export const GetAppSettingsByRestaurant = 'api/restaurant/{restaurantId}/get_app_settings';
export const GetCustomerDetails = 'api/customer/details?appVersion={app_version}';
export const GetDetails = 'api/restaurant_details/{id}/{locale}/{version}/{app_version}/{group}'; // cached in varnish
export const GetMenu = 'api/restaurant/{id_restaurant}/restaurant_menu/{locale}/{menu_version}/{group}/{app_version}';
export const AcceptCode = 'api/customer/enter_code';
export const CheckPhoneCode = 'api/customer/check_phone_code';
export const GetRestaurantList = 'api/navigation/{app_id}/{locale}/{app_version}';
export const GetRestaurantListByZip = 'api/restaurant/list/{appId}/{zip}/{locale}/{appVersion}';
export const SendOrder = 'api/customer/send_order';
export const SendDineInOrder = 'api/customer/send_dine_in_order';
export const SplitOrderLine = 'api/customer/dine_in/split_order_line';
export const PayForOthers = 'api/customer/dine_in/pay_for_others';
export const AskForBill = 'api/customer/dine_in/ask_for_bill';
export const AskForCheckout = 'api/customer/dine_in/ask_for_checkout';
export const CheckoutDineIn = 'api/customer/dine_in/checkout';
export const GetBill = 'api/customer/dine_in/bill';
export const CheckDineInDiscount = 'api/customer/dine_in_cart';
export const SetLocale = 'api/customer/set_locale';
export const GetAppTranslation = 'api/translation/locale/{locale}/{version}/app/{app_id}?appVersion={app_version}';
export const GetRestaurantTranslation =
	'api/translation/locale/{locale}/{version}/{restaurant_id}?appVersion={app_version}';
export const SetCardPassword = 'api/customer/set_payment_card_pass';
export const CancelOrder = 'api/customer/cancel_order';
export const CancelVippsPayment = 'api/customer/cancel_vipps_payment';
export const RegisterStripeCard =
	'api/customer/register_card/stripe?id={udid}&restaurantId={restaurantId}&appVersion={appVersion}';
export const DeleteCard = 'api/customer/delete_payment_card';
export const DeletePinAndCards = 'api/customer/delete_payment_pin';
export const WaiterConfirm = 'api/customer/waiter_confirm_order';
export const LoginAnonymous = 'api/customer/anonymous_sign_up';
export const LoginExternal =
	'api/customer/external_signup?restaurantId={restaurantId}&id={udid}&external_id={externalId}&phone={phone}&email={email}&first_name={firstName}&last_name={lastName}&signature={signature}';
export const LoginEntra =
	'api/customer/entra_sign_up?restaurantId={restaurantId}&id={udid}&entra_id={entraId}&phone={phone}&email={email}&first_name={firstName}&last_name={lastName}&hmac={hmac}';
export const OldOrders = 'api/customer/get_orders';
export const GetOrder = 'api/customer/get_order/{orderId}';
export const SetPhone = 'api/customer/set_phone';
export const SendClientLog = 'api/customer/send_log';
export const SetUsername = 'api/customer/set_nickname';
export const SetEmail = 'api/customer/set_email';
export const CheckConnection = 'check-server.php';
export const SendFeedback = 'api/customer/feedback';
export const SetUrbanAirshipChannelId = 'api/customer/device/set_urban_airship_channel_id';
export const EmailReceipts = 'api/customer/email_receipts';
export const RepeatOrder = 'api/customer/repeat_order';
export const SetTable = 'api/customer/set_table';
export const PingTable = 'api/customer/ping_table';
export const HistoryOrders = 'api/customer/history_page';
export const SetBirthdate = 'api/customer/set_birthdate';
export const CheckDiscount = 'api/customer/customer_cart_page';
export const SendReceipt = 'api/customer/send_receipt';
export const SendPushNotification = 'api/customer/demo_send_push_notification';
export const CheckZip = 'api/customer/check_zip';
export const CheckPaymentStatus = 'api/customer/check_payment_status/{orderId}';
export const ApplyPromoCode = 'api/customer/apply_promo_code';
export const Error = 'api/customer/emulate_error';
export const AddEventLog = 'api/customer/add_event_log';
export const MarkPopupAsShown = 'api/customer/popup/mark-as-shown';
export const ConfirmVoucher = 'api/customer/waiter_confirm_voucher';
export const GetCashPoints = 'api/customer/cash_points';
export const RecruitFriend = 'api/customer/recruit_a_friend';
export const AcceptTerms = 'api/customer/accept_terms';
export const AllowMarketing = 'api/customer/allow_marketing';
export const ResendPhoneCode = 'api/customer/resend_phone_code';
export const Resignup = 'api/customer/resign_up';
export const GetOrderDates = 'api/customer/get_order_dates';
export const GetOrderTimeSlots = 'api/customer/get_order_time_slots';
export const ReturnFromStripe = 'api/customer/return_from_stripe/{customerId}/{orderId}';
export const AppOrders = 'api/customer/orders?id={udid}&phonegap=false&webshop=false&appVersion={app_version}&appId={appId}';
export const InitAdyenPayment = 'api/customer/init_adyen_payment/{orderId}';
export const RegisterAdyenCard =
	'api/customer/register_card/adyen?id={udid}&restaurantId={restaurantId}&appVersion={appVersion}';
export const CheckAdyenPayment = 'api/customer/check_adyen_payment/{orderId}';
export const CheckPaymentStatusAnonymously = 'api/customer/check_payment_status_anon/{orderId}';
export const SetGuestInfo = 'api/customer/set_guest';
